// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about {
  min-height: 100vh;
  background: linear-gradient(135deg, #1D1136, #5734A4);
  padding: 2rem 1rem;
}

.about-container {
  max-width: 900px;
  margin: 0 auto;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  padding: 2rem;
}

.about-header {
  background: linear-gradient(135deg, #031A54, #1a237e);
  color: white;
  padding: 3rem 2rem;
  text-align: center;
}

.about-header h1 {
  margin: 0 0 1rem 0;
  font-size: 2.8rem;
  font-weight: 700;
}

.about-header p {
  margin: 0;
  font-size: 1.2rem;
  opacity: 0.9;
}

.about-content {
  padding: 3rem 2rem;
}

.about-section {
  margin-bottom: 3rem;
}

.about-section:last-child {
  margin-bottom: 0;
}

.about-section h2 {
  color: #1e3c72;
  font-size: 1.8rem;
  font-weight: 600;
  margin: 0 0 1.5rem 0;
  border-bottom: 3px solid #1e3c72;
  padding-bottom: 0.5rem;
}

.about-section p {
  line-height: 1.7;
  margin-bottom: 1rem;
  color: #333;
  font-size: 1.05rem;
}

.about-section ul {
  margin: 1rem 0;
  padding-left: 2rem;
}

.about-section li {
  margin-bottom: 0.5rem;
  line-height: 1.6;
}

.highlight-box {
  background: linear-gradient(135deg, #1e3c72, #2a5298);
  color: white;
  padding: 1.5rem;
  border-radius: 12px;
  text-align: center;
  font-size: 1.2rem;
  margin: 1.5rem 0;
  box-shadow: 0 4px 15px rgba(30, 60, 114, 0.3);
}

.metric-highlight {
  background: linear-gradient(135deg, #481CAF, #3a158f);
  color: white;
  padding: 1.2rem;
  border-radius: 8px;
  text-align: center;
  font-size: 1.1rem;
  margin: 1.5rem 0;
  box-shadow: 0 4px 15px rgba(72, 28, 175, 0.3);
}

.info-note {
  background: #e3f2fd;
  border-left: 4px solid #1e3c72;
  padding: 1rem 1.5rem;
  margin: 1.5rem 0;
  font-style: italic;
  color: #1565c0;
}

.terms-note {
  background: #fff3cd;
  border: 1px solid #ffeeba;
  color: #856404;
  padding: 0.75rem 1rem;
  border-radius: 6px;
  margin-top: 1rem;
  text-align: center;
  font-weight: 600;
}

.tier-title {
  background: linear-gradient(135deg, #481CAF, #3a158f);
  color: white !important;
  border: none !important;
  padding: 1rem 2rem;
  border-radius: 25px;
  text-align: center;
  box-shadow: 0 6px 20px rgba(72, 28, 175, 0.4);
  margin: 2rem 0 1.5rem 0 !important;
}

.level-card {
  background: #f8f9fa;
  border: 2px solid #e9ecef;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  transition: all 0.3s ease;
}

.level-card:hover {
  border-color: #1e3c72;
  box-shadow: 0 4px 15px rgba(30, 60, 114, 0.1);
  transform: translateY(-2px);
}

.level-card h3 {
  color: #1e3c72;
  margin: 0 0 1rem 0;
  font-size: 1.3rem;
  font-weight: 600;
}

.level-card p {
  margin: 0 0 0.5rem 0;
  color: #495057;
}

.level-card ul {
  margin: 0.5rem 0 0 0;
  padding-left: 1.5rem;
}

.level-card li {
  margin-bottom: 0.3rem;
  color: #495057;
}

.level-card.locked {
  background: #f5f5f5;
  border-color: #adb5bd;
  opacity: 0.7;
}

.level-card.locked h3 {
  color: #6c757d;
}

.leaderboard-link {
  text-align: center;
  margin-top: 3rem;
  padding-top: 2rem;
  border-top: 2px solid #e9ecef;
}

.leaderboard-link a {
  display: inline-block;
  background: linear-gradient(135deg, #1e3c72, #2a5298);
  color: white;
  text-decoration: none;
  padding: 1rem 2rem;
  border-radius: 25px;
  font-weight: 600;
  font-size: 1.1rem;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(30, 60, 114, 0.3);
}

.leaderboard-link a:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(30, 60, 114, 0.4);
  text-decoration: none;
  color: white;
}

/* Responsive Design */
@media (max-width: 768px) {
  .about {
    padding: 1rem;
  }

  .about-container {
    padding: 1.5rem;
  }

  .about-header {
    padding: 2rem 1.5rem;
  }

  .about-header h1 {
    font-size: 2.2rem;
  }

  .about-content {
    padding: 2rem 1.5rem;
  }

  .about-section h2 {
    font-size: 1.5rem;
  }

  .tier-title {
    font-size: 1.4rem !important;
    padding: 0.8rem 1.5rem;
  }

  .level-card {
    padding: 1.2rem;
  }

  .highlight-box,
  .metric-highlight {
    padding: 1rem;
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .about-container {
    padding: 1rem;
  }

  .about-header h1 {
    font-size: 1.8rem;
  }

  .about-section h2 {
    font-size: 1.3rem;
  }

  .tier-title {
    font-size: 1.2rem !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/About.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6C;EAC7C,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,qDAAqD;EACrD,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,qBAAqB;EACrB,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,4BAA4B;IAC5B,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,aAAa;IACb,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,4BAA4B;EAC9B;AACF","sourcesContent":[".about {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #1D1136, #5734A4);\n  padding: 2rem 1rem;\n}\n\n.about-container {\n  max-width: 900px;\n  margin: 0 auto;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n  padding: 2rem;\n}\n\n.about-header {\n  background: linear-gradient(135deg, #031A54, #1a237e);\n  color: white;\n  padding: 3rem 2rem;\n  text-align: center;\n}\n\n.about-header h1 {\n  margin: 0 0 1rem 0;\n  font-size: 2.8rem;\n  font-weight: 700;\n}\n\n.about-header p {\n  margin: 0;\n  font-size: 1.2rem;\n  opacity: 0.9;\n}\n\n.about-content {\n  padding: 3rem 2rem;\n}\n\n.about-section {\n  margin-bottom: 3rem;\n}\n\n.about-section:last-child {\n  margin-bottom: 0;\n}\n\n.about-section h2 {\n  color: #1e3c72;\n  font-size: 1.8rem;\n  font-weight: 600;\n  margin: 0 0 1.5rem 0;\n  border-bottom: 3px solid #1e3c72;\n  padding-bottom: 0.5rem;\n}\n\n.about-section p {\n  line-height: 1.7;\n  margin-bottom: 1rem;\n  color: #333;\n  font-size: 1.05rem;\n}\n\n.about-section ul {\n  margin: 1rem 0;\n  padding-left: 2rem;\n}\n\n.about-section li {\n  margin-bottom: 0.5rem;\n  line-height: 1.6;\n}\n\n.highlight-box {\n  background: linear-gradient(135deg, #1e3c72, #2a5298);\n  color: white;\n  padding: 1.5rem;\n  border-radius: 12px;\n  text-align: center;\n  font-size: 1.2rem;\n  margin: 1.5rem 0;\n  box-shadow: 0 4px 15px rgba(30, 60, 114, 0.3);\n}\n\n.metric-highlight {\n  background: linear-gradient(135deg, #481CAF, #3a158f);\n  color: white;\n  padding: 1.2rem;\n  border-radius: 8px;\n  text-align: center;\n  font-size: 1.1rem;\n  margin: 1.5rem 0;\n  box-shadow: 0 4px 15px rgba(72, 28, 175, 0.3);\n}\n\n.info-note {\n  background: #e3f2fd;\n  border-left: 4px solid #1e3c72;\n  padding: 1rem 1.5rem;\n  margin: 1.5rem 0;\n  font-style: italic;\n  color: #1565c0;\n}\n\n.terms-note {\n  background: #fff3cd;\n  border: 1px solid #ffeeba;\n  color: #856404;\n  padding: 0.75rem 1rem;\n  border-radius: 6px;\n  margin-top: 1rem;\n  text-align: center;\n  font-weight: 600;\n}\n\n.tier-title {\n  background: linear-gradient(135deg, #481CAF, #3a158f);\n  color: white !important;\n  border: none !important;\n  padding: 1rem 2rem;\n  border-radius: 25px;\n  text-align: center;\n  box-shadow: 0 6px 20px rgba(72, 28, 175, 0.4);\n  margin: 2rem 0 1.5rem 0 !important;\n}\n\n.level-card {\n  background: #f8f9fa;\n  border: 2px solid #e9ecef;\n  border-radius: 12px;\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n  transition: all 0.3s ease;\n}\n\n.level-card:hover {\n  border-color: #1e3c72;\n  box-shadow: 0 4px 15px rgba(30, 60, 114, 0.1);\n  transform: translateY(-2px);\n}\n\n.level-card h3 {\n  color: #1e3c72;\n  margin: 0 0 1rem 0;\n  font-size: 1.3rem;\n  font-weight: 600;\n}\n\n.level-card p {\n  margin: 0 0 0.5rem 0;\n  color: #495057;\n}\n\n.level-card ul {\n  margin: 0.5rem 0 0 0;\n  padding-left: 1.5rem;\n}\n\n.level-card li {\n  margin-bottom: 0.3rem;\n  color: #495057;\n}\n\n.level-card.locked {\n  background: #f5f5f5;\n  border-color: #adb5bd;\n  opacity: 0.7;\n}\n\n.level-card.locked h3 {\n  color: #6c757d;\n}\n\n.leaderboard-link {\n  text-align: center;\n  margin-top: 3rem;\n  padding-top: 2rem;\n  border-top: 2px solid #e9ecef;\n}\n\n.leaderboard-link a {\n  display: inline-block;\n  background: linear-gradient(135deg, #1e3c72, #2a5298);\n  color: white;\n  text-decoration: none;\n  padding: 1rem 2rem;\n  border-radius: 25px;\n  font-weight: 600;\n  font-size: 1.1rem;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(30, 60, 114, 0.3);\n}\n\n.leaderboard-link a:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(30, 60, 114, 0.4);\n  text-decoration: none;\n  color: white;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .about {\n    padding: 1rem;\n  }\n\n  .about-container {\n    padding: 1.5rem;\n  }\n\n  .about-header {\n    padding: 2rem 1.5rem;\n  }\n\n  .about-header h1 {\n    font-size: 2.2rem;\n  }\n\n  .about-content {\n    padding: 2rem 1.5rem;\n  }\n\n  .about-section h2 {\n    font-size: 1.5rem;\n  }\n\n  .tier-title {\n    font-size: 1.4rem !important;\n    padding: 0.8rem 1.5rem;\n  }\n\n  .level-card {\n    padding: 1.2rem;\n  }\n\n  .highlight-box,\n  .metric-highlight {\n    padding: 1rem;\n    font-size: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .about-container {\n    padding: 1rem;\n  }\n\n  .about-header h1 {\n    font-size: 1.8rem;\n  }\n\n  .about-section h2 {\n    font-size: 1.3rem;\n  }\n\n  .tier-title {\n    font-size: 1.2rem !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
